var sku_values_l = ''; //Valor de todas las combinaciones colocadas en el ojo izquierdo
var sku_values_r = ''; //Valor de todas las combinaciones colocadas en el ojo derecho
var var_l_sph = ''; //Este es el valor del SPH en el ojo izquierdo
var var_r_sph = ''; //Este es el valor del SPH en el ojo derecho
var l_times = 0;
var r_times = 0;

$('#right-upc input, #left-upc input').val(val_upc);
	
$('#left-graduacion').click(function() {
    var_l_sph = $('#7491236856002_option_3').val();
	console.log(var_l_sph); 
	unify_values_l();
	fetch_sku_l();
});


$('#right-graduacion').click(function() {
    var_r_sph = $('#7491236856002_option_4').val();
	console.log(var_r_sph); 
	unify_values_r();
	fetch_sku_r();
});


function unify_values_l(){
	sku_values_l = var_l_sph ;
	console.log(sku_values_l);
}

function unify_values_r(){
	sku_values_r = var_r_sph;
	console.log(sku_values_r);
}

function check_times(){
  // 2 = Inmediata, 3 = Exportación, 4 = sin stock
  setTimeout(function(){
    if (l_times == 2){$('.lens-add-btn, .alertLens').show(); $('#left-stock').hide();} 
    if (l_times == 3){$('.lens-add-btn, .alertLens').show(); $('#left-stock').hide();} 
    if (r_times == 2){$('.lens-add-btn, .alertLens').show(); $('#right-stock').hide();} 
    if (r_times == 3){$('.lens-add-btn, .alertLens').show(); $('#right-stock').hide();} 
    if (l_times == 4){$('#left-stock').show(); $('.lens-add-btn, .alertLens').hide();} 
    if (r_times == 4){$('#right-stock').show(); $('.lens-add-btn, .alertLens').hide();} 
  },300);
}

function fetch_sku_l(){
 	switch (sku_values_l) { 
case '-0.25' : $('#left-sku input').val('1158742001'); l_times = 2; check_times(); break;
case '-0.50' : $('#left-sku input').val('1158742002'); l_times = 2; check_times(); break;
case '-0.75' : $('#left-sku input').val('1158742003'); l_times = 2; check_times(); break;
case '-1.00' : $('#left-sku input').val('1158742004'); l_times = 2; check_times(); break;
case '-1.25' : $('#left-sku input').val('1158742005'); l_times = 2; check_times(); break;
case '-1.50' : $('#left-sku input').val('1158742006'); l_times = 2; check_times(); break;
case '-1.75' : $('#left-sku input').val('1158742007'); l_times = 2; check_times(); break;
case '-2.00' : $('#left-sku input').val('1158742008'); l_times = 2; check_times(); break;
case '-2.25' : $('#left-sku input').val('1158742009'); l_times = 2; check_times(); break;
case '-2.50' : $('#left-sku input').val('1158742010'); l_times = 2; check_times(); break;
case '-2.75' : $('#left-sku input').val('1158742011'); l_times = 2; check_times(); break;
case '-3.00' : $('#left-sku input').val('1158742012'); l_times = 2; check_times(); break;
case '-3.25' : $('#left-sku input').val('1158742013'); l_times = 2; check_times(); break;
case '-3.50' : $('#left-sku input').val('1158742014'); l_times = 2; check_times(); break;
case '-3.75' : $('#left-sku input').val('1158742015'); l_times = 2; check_times(); break;
case '-4.00' : $('#left-sku input').val('1158742016'); l_times = 2; check_times(); break;
case '-4.25' : $('#left-sku input').val('1158742017'); l_times = 2; check_times(); break;
case '-4.50' : $('#left-sku input').val('1158742018'); l_times = 2; check_times(); break;
case '-4.75' : $('#left-sku input').val('1158742019'); l_times = 2; check_times(); break;
case '-5.00' : $('#left-sku input').val('1158742020'); l_times = 2; check_times(); break;
case '-5.25' : $('#left-sku input').val('1158742021'); l_times = 2; check_times(); break;
case '-5.50' : $('#left-sku input').val('1158742022'); l_times = 2; check_times(); break;
case '-5.75' : $('#left-sku input').val('1158742023'); l_times = 2; check_times(); break;
case '-6.00' : $('#left-sku input').val('1158742024'); l_times = 2; check_times(); break;
case '-6.50' : $('#left-sku input').val('1158742025'); l_times = 2; check_times(); break;
case '-7.00' : $('#left-sku input').val('1158742026'); l_times = 2; check_times(); break;
case '-7.50' : $('#left-sku input').val('1158742027'); l_times = 2; check_times(); break;
case '-8.00' : $('#left-sku input').val('1158742028'); l_times = 2; check_times(); break;
case '-8.50' : $('#left-sku input').val('1158742029'); l_times = 2; check_times(); break;
case '-9.00' : $('#left-sku input').val('1158742030'); l_times = 2; check_times(); break;
case '-9.50' : $('#left-sku input').val('1158742031'); l_times = 2; check_times(); break;
case '-10.00' : $('#left-sku input').val('1158742032'); l_times = 2; check_times(); break;
case '-10.50' : $('#left-sku input').val('1158742033'); l_times = 2; check_times(); break;
case '-11.00' : $('#left-sku input').val('1158742034'); l_times = 2; check_times(); break;
case '-11.50' : $('#left-sku input').val('1158742035'); l_times = 2; check_times(); break;
case '-12.00' : $('#left-sku input').val('1158742036'); l_times = 2; check_times(); break;
case '+0.25' : $('#left-sku input').val('1158742037'); l_times = 2; check_times(); break;
case '+0.50' : $('#left-sku input').val('1158742038'); l_times = 2; check_times(); break;
case '+0.75' : $('#left-sku input').val('1158742039'); l_times = 2; check_times(); break;
case '+1.00' : $('#left-sku input').val('1158742040'); l_times = 2; check_times(); break;
case '+1.25' : $('#left-sku input').val('1158742041'); l_times = 2; check_times(); break;
case '+1.50' : $('#left-sku input').val('1158742042'); l_times = 2; check_times(); break;
case '+1.75' : $('#left-sku input').val('1158742043'); l_times = 2; check_times(); break;
case '+2.00' : $('#left-sku input').val('1158742044'); l_times = 2; check_times(); break;
case '+2.25' : $('#left-sku input').val('1158742045'); l_times = 2; check_times(); break;
case '+2.50' : $('#left-sku input').val('1158742046'); l_times = 2; check_times(); break;
case '+2.75' : $('#left-sku input').val('1158742047'); l_times = 2; check_times(); break;
case '+3.00' : $('#left-sku input').val('1158742048'); l_times = 2; check_times(); break;
case '+3.50' : $('#left-sku input').val('1158742050'); l_times = 2; check_times(); break;
case '+4.00' : $('#left-sku input').val('1158742052'); l_times = 2; check_times(); break;

case 'null' : l_times = 4 ; check_times(); break;
default: $('#left-sku input').val('SKU Desconocido'); l_times = 4; check_times(); break; 

    }
}//fetch_sku()

function fetch_sku_r(){
 	switch (sku_values_r) {
case '-0.25' : $('#right-sku input').val('1158742001'); r_times = 2; check_times(); break;
case '-0.50' : $('#right-sku input').val('1158742002'); r_times = 2; check_times(); break;
case '-0.75' : $('#right-sku input').val('1158742003'); r_times = 2; check_times(); break;
case '-1.00' : $('#right-sku input').val('1158742004'); r_times = 2; check_times(); break;
case '-1.25' : $('#right-sku input').val('1158742005'); r_times = 2; check_times(); break;
case '-1.50' : $('#right-sku input').val('1158742006'); r_times = 2; check_times(); break;
case '-1.75' : $('#right-sku input').val('1158742007'); r_times = 2; check_times(); break;
case '-2.00' : $('#right-sku input').val('1158742008'); r_times = 2; check_times(); break;
case '-2.25' : $('#right-sku input').val('1158742009'); r_times = 2; check_times(); break;
case '-2.50' : $('#right-sku input').val('1158742010'); r_times = 2; check_times(); break;
case '-2.75' : $('#right-sku input').val('1158742011'); r_times = 2; check_times(); break;
case '-3.00' : $('#right-sku input').val('1158742012'); r_times = 2; check_times(); break;
case '-3.25' : $('#right-sku input').val('1158742013'); r_times = 2; check_times(); break;
case '-3.50' : $('#right-sku input').val('1158742014'); r_times = 2; check_times(); break;
case '-3.75' : $('#right-sku input').val('1158742015'); r_times = 2; check_times(); break;
case '-4.00' : $('#right-sku input').val('1158742016'); r_times = 2; check_times(); break;
case '-4.25' : $('#right-sku input').val('1158742017'); r_times = 2; check_times(); break;
case '-4.50' : $('#right-sku input').val('1158742018'); r_times = 2; check_times(); break;
case '-4.75' : $('#right-sku input').val('1158742019'); r_times = 2; check_times(); break;
case '-5.00' : $('#right-sku input').val('1158742020'); r_times = 2; check_times(); break;
case '-5.25' : $('#right-sku input').val('1158742021'); r_times = 2; check_times(); break;
case '-5.50' : $('#right-sku input').val('1158742022'); r_times = 2; check_times(); break;
case '-5.75' : $('#right-sku input').val('1158742023'); r_times = 2; check_times(); break;
case '-6.00' : $('#right-sku input').val('1158742024'); r_times = 2; check_times(); break;
case '-6.50' : $('#right-sku input').val('1158742025'); r_times = 2; check_times(); break;
case '-7.00' : $('#right-sku input').val('1158742026'); r_times = 2; check_times(); break;
case '-7.50' : $('#right-sku input').val('1158742027'); r_times = 2; check_times(); break;
case '-8.00' : $('#right-sku input').val('1158742028'); r_times = 2; check_times(); break;
case '-8.50' : $('#right-sku input').val('1158742029'); r_times = 2; check_times(); break;
case '-9.00' : $('#right-sku input').val('1158742030'); r_times = 2; check_times(); break;
case '-9.50' : $('#right-sku input').val('1158742031'); r_times = 2; check_times(); break;
case '-10.00' : $('#right-sku input').val('1158742032'); r_times = 2; check_times(); break;
case '-10.50' : $('#right-sku input').val('1158742033'); r_times = 2; check_times(); break;
case '-11.00' : $('#right-sku input').val('1158742034'); r_times = 2; check_times(); break;
case '-11.50' : $('#right-sku input').val('1158742035'); r_times = 2; check_times(); break;
case '-12.00' : $('#right-sku input').val('1158742036'); r_times = 2; check_times(); break;
case '+0.25' : $('#right-sku input').val('1158742037'); r_times = 2; check_times(); break;
case '+0.50' : $('#right-sku input').val('1158742038'); r_times = 2; check_times(); break;
case '+0.75' : $('#right-sku input').val('1158742039'); r_times = 2; check_times(); break;
case '+1.00' : $('#right-sku input').val('1158742040'); r_times = 2; check_times(); break;
case '+1.25' : $('#right-sku input').val('1158742041'); r_times = 2; check_times(); break;
case '+1.50' : $('#right-sku input').val('1158742042'); r_times = 2; check_times(); break;
case '+1.75' : $('#right-sku input').val('1158742043'); r_times = 2; check_times(); break;
case '+2.00' : $('#right-sku input').val('1158742044'); r_times = 2; check_times(); break;
case '+2.25' : $('#right-sku input').val('1158742045'); r_times = 2; check_times(); break;
case '+2.50' : $('#right-sku input').val('1158742046'); r_times = 2; check_times(); break;
case '+2.75' : $('#right-sku input').val('1158742047'); r_times = 2; check_times(); break;
case '+3.00' : $('#right-sku input').val('1158742048'); r_times = 2; check_times(); break;
case '+3.50' : $('#right-sku input').val('1158742050'); r_times = 2; check_times(); break;
case '+4.00' : $('#right-sku input').val('1158742052'); r_times = 2; check_times(); break;

case 'null' : r_times = 4 ; check_times(); break;
default: $('#right-sku input').val('SKU Desconocido'); r_times = 4; check_times(); break; 
    }
}//fetch_sku()
